const wqBlocks = document.querySelectorAll('.block-table-water-quality');

const setEcoliClasses = (block) => {
	const tables = block.querySelectorAll(
		'.block-table-water-quality__col--table table'
	);

	if (!tables.length) return;

	tables.forEach((table) => {
		const headerCells = table.querySelectorAll('thead th');
		if (!headerCells.length) return;

		let ecoliColIndex = -1;

		headerCells.forEach((th, idx) => {
			const text = (th.textContent || '').trim().toLowerCase();
			if (
				text.includes('e. coli') ||
				text.includes('ecoli') ||
				text.includes('e coli')
			) {
				ecoliColIndex = idx;
			}
		});

		if (ecoliColIndex === -1) return;

		const rows = table.querySelectorAll('tbody tr');
		rows.forEach((row) => {
			const cells = row.querySelectorAll('td');
			const ecoliTd = cells[ecoliColIndex];

			if (!ecoliTd) return;

			const raw = (ecoliTd.textContent || '').trim();
			const cleaned = raw.replace(/[^\d.]/g, '');
			const value = parseFloat(cleaned);

			ecoliTd.classList.remove('is-high', 'is-low');

			if (!Number.isFinite(value)) return;

			if (value > 235) {
				ecoliTd.classList.add('is-high');
			} else {
				ecoliTd.classList.add('is-low');
			}
		});
	});
};

if (wqBlocks.length) {
	wqBlocks.forEach((block) => {
		setEcoliClasses(block);
	});
}
